import typeCheck from 'common/util/typeCheck';
import { SR_API_ACTION_GET_LISTING_LINKS } from 'api/actionTypes';

export default async function getListingLinks({ state, apiClient }, { listingId, forceRefresh }) {
  typeCheck('listingId::PositiveNumber', listingId);
  const statePath = ['listingLinksByListingId', listingId];
  if (state.exists(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_LINKS,
    state: state,
    queryId: `${listingId}`,
    payload: {
      listingId,
    },
    onSuccess({ listingLinks }) {
      state.set(statePath, listingLinks);
    },
  });
}
